/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';
import SingleCard from './SingleCard';

export default function BlogCard() {
    const blogs = useSelector((state) => state.blogs);
    const filters = useSelector((state) => state.filters);

    const sameCategoryBlogs = (blog) => {
        switch (filters.category) {
            case blog.category:
                return true;
            case 'All':
                return true;
            default:
                return false;
        }
    };

    const sameAuthorBlogs = (blog) => {
        switch (filters.author) {
            case blog.author:
                return true;
            case 'All':
                return true;
            default:
                return false;
        }
    };

    const searchBlogs = (blog) => {
        if (filters.query === '') {
            return true;
        }
        if (blog.title.toLowerCase().includes(filters.query.toLowerCase())) {
            return true;
        }

        return false;
    };
    return (
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
            {blogs
                .filter(searchBlogs)
                .filter(sameCategoryBlogs)
                .filter(sameAuthorBlogs)
                .map((blog) => (
                    <SingleCard blog={blog} key={blog.id} />
                ))}
        </div>
    );
}
